import type { RouteRecordRaw } from "vue-router"
import { useProveConfig } from "@versatile-credit-apply/sdk"

export const ProveRoutes: RouteRecordRaw[] = [
  {
    path: "prove",
    children: [
      {
        path: "",
        redirect: ({ fullPath }) => {
          const config = useProveConfig()
          if (config.value?.proveVerificationProvider == "ads_prove") {
            return "/apply/providers/ads_standard/prove/challenge"
          }
          return `${fullPath}/challenge`
        },
      },
      {
        path: "challenge",
        name: "prove-challenge",
        component: () => import("./ProveChallengePage.vue"),
      },
      {
        path: "instant-link",
        name: "prove-instant-link",
        component: () => import("./ProveInstantLinkPage.vue"),
        meta: {
          preventBack: true,
        },
      },
      {
        path: "verifying",
        name: "prove-verification-progress",
        component: () => import("./ProveVerificationProgressPage.vue"),
        meta: {
          preventBack: true,
        },
      },
      {
        path: "verified",
        name: "prove-verified",
        component: () => import("./ProveVerifiedPage.vue"),
        meta: {
          preventBack: true,
        },
      },
      {
        path: "edit-information",
        name: "prove-edit-information",
        component: () => import("./ProveEditInformationPage.vue"),
      },
    ],
  },
]
